import { Routes, Route, useParams } from 'react-router-dom'

import Home from './pages/Home'
import Pricing from './pages/Pricing'
import Pipeline from './pages/Pipeline'
import PropertyDashboard from './pages/PropertyDashboard'
import Arv from './pages/Arv'
import Flip from './pages/Flip'
import ListingDetails from './pages/ListingDetails'
import Login from './pages/Login'
import Signup from './pages/Signup'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import PasswordUpdated from './pages/PasswordUpdated'
import Payment from './pages/Payment'
import PaymentSuccess from './pages/PaymentSuccess'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'
import ProtectedRoute from './components/ProtectedRoute'
import ScrollToTop from './components/ScrollToTop'
import ExpiredModal from './features/subscription/ExpiredModal'

// Arv seeds nine state entries from the route on mount; without a key the instance is reused
// across property ids and write handlers act on the previous property's data.
function ArvRoute() {
  const { id } = useParams()
  return <Arv key={id} />
}

// Same hazard as ArvRoute above: without this key, Flip's own scenario state (seeded once per
// mount) would survive a navigation between two properties' Flip screens.
function FlipRoute() {
  const { id } = useParams()
  return <Flip key={id} />
}

// Same hazard as ArvRoute above: this key is what resets PropertyDashboard's loading/error state and
// failedSavesRef -- the only ref ever hand-cleared before -- on an id change. Removing it reopens the
// confirmed-value leak and stale state carryover; see src/pages/README.md.
function PropertyDashboardRoute() {
  const { id } = useParams()
  return <PropertyDashboard key={id} />
}

function App() {
  return (
    <>
    <ScrollToTop />
    <ExpiredModal />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/pipeline" element={
        <ProtectedRoute><Pipeline /></ProtectedRoute>
      } />
      <Route path="/property/:id" element={
        <ProtectedRoute><PropertyDashboardRoute /></ProtectedRoute>
      } />
      <Route path="/property/:id/arv" element={
        <ProtectedRoute><ArvRoute /></ProtectedRoute>
      } />
      <Route path="/property/:id/flip" element={
        <ProtectedRoute><FlipRoute /></ProtectedRoute>
      } />
      <Route path="/property/:id/arv/listing/:listingIndex" element={
        <ProtectedRoute><ListingDetails /></ProtectedRoute>
      } />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/password-updated" element={<PasswordUpdated />} />
      <Route path="/payment" element={
        <ProtectedRoute><Payment /></ProtectedRoute>
      } />
      <Route path="/payment/success" element={
        <ProtectedRoute><PaymentSuccess /></ProtectedRoute>
      } />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
    </Routes>
    </>
  )
}

export default App
